import { useState } from "react"
import { Modal, Typography } from "antd"
import { ListaSoportes } from "./ListaSoportes"
import { FormularioReemplazo } from "./FormularioReemplazo"

const { Title } = Typography

export function ModalSoporteReemplazo({ open, onOpenChange, limpiar }) {
  const [mostrarFormulario, setMostrarFormulario] = useState(false)
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  const handleCrearReemplazo = () => {
    setMostrarFormulario(true)
  }

  const handleFormularioSuccess = () => {
    setMostrarFormulario(false)
    setRefreshTrigger(prev => prev + 1)
  }

  const handleFormularioCancel = () => {
    setMostrarFormulario(false)
  }

  const handleModalClose = () => {
    setMostrarFormulario(false) // Resetea el formulario cuando se cierra
    onOpenChange(false)
  }

  return (
    <Modal
      open={open}
      destroyOnHidden
      onCancel={handleModalClose}
      footer={null}
      width="90%"
      style={{ top: 20 }}
      styles={{ body: { maxHeight: "80vh", overflowY: "auto" } }}
      title={<Title level={3}>Sistema de Reemplazo de Soportes</Title>}
    >
      {mostrarFormulario ? (
        <FormularioReemplazo
          onSuccess={handleFormularioSuccess}
          onCancel={handleFormularioCancel}
        />
      ) : (
        <ListaSoportes
          onCrearReemplazo={handleCrearReemplazo}
          refreshTrigger={refreshTrigger}
          limpiar={limpiar}
        />
      )}
    </Modal>
  )
}
